function normalizeSearchText(value = '') {
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .trim();
}

export function filterConversations(conversations = [], keyword = '') {
  const query = normalizeSearchText(keyword);
  if (!query) return conversations;

  return conversations.filter((conversation) => {
    const searchable = normalizeSearchText([
      conversation?.title,
      conversation?.name,
      conversation?.lastMessagePreview,
      conversation?.type
    ].filter(Boolean).join(' '));

    return searchable.includes(query);
  });
}
